import BaseEntity from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import {
  managementSelectors,
  pageSelectors,
  useManagement,
  usePage,
} from 'client/store'
import CommonFaq, { FaqItem } from 'common/components/entities/Faq'
import { FaqInterface, FaqItemInterface } from 'src/shared/entities/faq/faq.schema'
import { CustomFontProperties } from 'common/utils/fontsUtils'
import React from 'react'

type FaqProps = {
  entity: FaqInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function Faq({ entity, isMoveDownAllowed, isMoveUpAllowed }: FaqProps) {
  const activeIndex = useManagement(management =>
    managementSelectors.getEntityInnerItemActiveIndex(management, entity.id),
  )
  const faqItems = usePage(page =>
    pageSelectors.getChildrenEntities(page, entity.childIds),
  ) as FaqItemInterface[]

  return (
    <BaseEntity
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonFaq
        mobilePadding={entity.mobilePadding}
        padding={entity.padding}
        htmlAttrId={entity.htmlAttrId}
        spaceBetweenItems={entity.spaceBetweenItems}
      >
        {faqItems.map((faqItem, index) => (
          <FaqItem
            key={faqItem.id}
            showIcons={entity.showIcons}
            mobileShowIcons={entity.mobileShowIcons}
            itemBorderRadius={entity.itemBorderRadius}
            itemPadding={entity.itemPadding}
            mobileItemPadding={entity.mobileItemPadding}
            backgroundColor={entity.backgroundColor}
            mobileBackgroundColor={entity.mobileBackgroundColor}
            titleColor={entity.titleColor}
            mobileTitleColor={entity.mobileTitleColor}
            titleFontSize={entity.titleFontSize}
            titleFontFamily={entity.titleFontFamily}
            titleFontStyle={entity.titleFontStyle}
            titleFontWeight={entity.titleFontWeight}
            fontFileId={entity.fontFileId}
            mobileTitleFontSize={entity.mobileTitleFontSize}
            mobileTitleFontWeight={entity.mobileTitleFontWeight}
            mobileTitleFontStyle={entity.mobileTitleFontStyle}
            mobileTitleFontFamily={entity.mobileTitleFontFamily}
            mobileFontFileId={entity.mobileFontFileId}
            title={faqItem.title}
            expanded={activeIndex === index}
            iconClassName={entity.iconClassName}
            closedIconClassName={entity.closedIconClassName}
            iconColor={entity.iconColor}
            mobileIconColor={entity.mobileIconColor}
            boxShadow={entity.boxShadow}
            mobileBoxShadow={entity.mobileBoxShadow}
          >
            <ChildrenEntities
              id={faqItem.id}
              isReadOnly={faqItem.isReadOnly}
              type={faqItem.type}
              childIds={faqItem.childIds}
              placeholderText="entities.faq.empty_dropbox_text"
            />
          </FaqItem>
        ))}
      </CommonFaq>
    </BaseEntity>
  )
}

export function getFaqFontProperties(entity: FaqInterface) {
  return entity.titleFontFamily
    ? [
        {
          fontFamily: entity.titleFontFamily,
          fontStyle: entity.titleFontStyle,
          fontWeight: entity.titleFontWeight,
        },
      ]
    : []
}

export function getFaqCustomFontProperties(entity: FaqInterface) {
  const customFonts: CustomFontProperties[] = []
  // that's not a mistake, we have titleFontFamily and fontFileId
  if (entity.titleFontFamily && entity.fontFileId) {
    customFonts.push({
      fontFamily: entity.titleFontFamily,
      fontFileId: entity.fontFileId,
    })
  }

  if (entity.mobileTitleFontFamily && entity.mobileFontFileId) {
    customFonts.push({
      fontFamily: entity.mobileTitleFontFamily,
      fontFileId: entity.mobileFontFileId,
    })
  }
  return customFonts
}
export default Faq
